<template>
  <div>
    <van-nav-bar :border="false">
      <template #left><span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span></template>
      <template #title> <strong>意见反馈</strong> </template>
    </van-nav-bar>
    <div class="form">
      <div class="form-item">
        <div class="label">联系电话</div>
        <div class="input"><input ref="mobile" v-model="mobile" type="number" placeholder="请输入联系电话" @input="limitNum($refs.mobile, 'mobile', 11)"></div>
      </div>
      <div class="form-item">
        <div class="label">反馈类型</div>
        <div class="input feedback van-icon van-icon--down" @click="show = true">
          <span v-if="!type" class="color-757575">点击选择反馈类型</span>
          <span v-else>{{ type }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="label">详细描述</div>
        <div class="input">
          <textarea v-model="content" cols="30" rows="10" placeholder="请详细描述问题"></textarea>
        </div>
      </div>
      <div class="form-item" @click="submitProblem"><van-button color="#409eff" size="large" round class="mt-10">提交</van-button></div>
    </div>
    <van-action-sheet v-model="show" :actions="typeOptions" @select="onSelect" />
  </div>
</template>

<script>
import { submitProblem } from '@/api/common.js'
import { mapState } from 'vuex'
import LimitNum from '@/mixins/number-limit.js'
export default {
  name: 'Feedback',
  mixins: [LimitNum],
  data() {
    return {
      loading: false,
      show: false, // 动作面板的显示控制
      mobile: '',
      type: '', // 反馈类型
      content: ''
    }
  },
  computed: {
    typeOptions() {
      return [
        { name: '注册类', color: this.type === '注册类' ? '#409eff' : '' },
        { name: '信息填写', color: this.type === '信息填写' ? '#409eff' : '' },
        { name: '权属类', color: this.type === '权属类' ? '#409eff' : '' },
        { name: 'BUG类', color: this.type === 'BUG类' ? '#409eff' : '' },
        { name: '发行渠道', color: this.type === '发行渠道' ? '#409eff' : '' },
        { name: '作品管理', color: this.type === '作品管理' ? '#409eff' : '' },
        { name: '账单类', color: this.type === '账单类' ? '#409eff' : '' },
        { name: '提现类', color: this.type === '提现类' ? '#409eff' : '' },
        { name: '操作类', color: this.type === '操作类' ? '#409eff' : '' }]
    },
    ...mapState(['userInfo'])
  },
  created() {
    this.mobile = this.userInfo.username
  },
  methods: {
    async submitProblem() {
      try {
        if (!this.type) {
          this.$toast('问题类型不能为空!')
          return
        }
        this.$store.commit('TOGGLE_LOADING', true)
        const res = await submitProblem({ mobile: this.mobile, type: this.type, content: this.content })
        this.$toast(res.msg)
        this.type = ''
        this.content = ''
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    onSelect(item) {
      this.type = item.name
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item{
  padding: 5px 15px;
  .label{
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  .input{
    display: flex;
    input, textarea{
      flex-grow: 1;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      transition: border-color .2s;
      -webkit-appearance:none;
      &:focus{
        border-color: #409eff;
      }
    }
    input{
      text-indent: 10px;
      height: 35px;
      line-height: 35px;
    }
    textarea{
      height: 150px;
      padding: 5px 10px;
      resize: none;
    }
  }
  .feedback{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    line-height: 35px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    transition: border-color .2s;
    -webkit-appearance:none;
    padding: 0 10px;
    &::after{
      content: "\F007";
    }
    &::before{
      display: none;
    }
    &:focus{
      border-color: #409eff;
    }
  }
}
</style>
